import { FC } from "react";
import styles from "./AirlineList.module.scss";

type AirlineRowProps = {
  title: string;
  value: string | null;
};

export const AirlineRow: FC<AirlineRowProps> = ({ title, value }) => {
  return (
    <div className={styles.row}>
      <div className={styles.title}>{title}</div>
      <div className={styles.value}>{value}</div>
    </div>
  );
};
